import {useOutletContext, useParams} from "react-router-dom";
import {Button} from "primereact/button";
import React, {useEffect, useRef, useState} from "react";
import {useFormik} from "formik";
import Loader from "../components/Loader";
import FormGroup from "../components/FormGroup";
import {InputText} from "primereact/inputtext";
import {SelectButton} from "primereact/selectbutton";
import {Calendar} from "primereact/calendar";
import {useSelector} from "react-redux";
import {DepartmentService} from "../services/DepartmentService";
import {Dropdown} from "primereact/dropdown";
import {InputNumber} from "primereact/inputnumber";
import {confirmPopup} from "primereact/confirmpopup";
import {classNames} from "primereact/utils";
import {ScrollPanel} from "primereact/scrollpanel";
import {ClientService} from "../services/ClientService";
import {Toast} from "primereact/toast";
import {Checkbox} from "primereact/checkbox";
import {RadioButton} from "primereact/radiobutton";

export default function ClientContracts(props) {

    const locationParams = useParams()
    const contractType = locationParams.type || 'all'
    const context = useOutletContext()
    const [client, setClient] = useState(false)
    const [isLoaded, setIsLoaded] = useState(false)
    const currentDepartment = useSelector(function (state) {
        return state.currentDepartment
    });
    const [groups, setGroups] = useState(false)
    const [additionals, setAdditionals] = useState([])
    const [status, setStatus] = useState([])
    const toast = useRef()

    const contractTypes = {
        kindergarten: 'Детский клуб',
        additional_class: 'Доп. занятия',
        individual_lesson: 'Индивидуальные занятия',
        summer_camp: 'Летний лагерь',
        school: 'Школа',
    };

    const contractStatuses = [
        {name: 'Активный', value: 100},
        {name: 'Повторный год', value: 95},
        {name: 'Истек', value: 80},
        {name: 'Перспективный', value: 90},
        {name: 'Расторгнут', value: 70},
        {name: 'Выпускник', value: 60},
    ];

    const addContract = (e) => {
        formik.setFieldValue('contracts', [...formik.values.contracts, initialContractData({editing: true})], false)
    }

    const contract = (item) => {
        <>

        </>
    }

    const initialContractData = (contract) => {
        const data = {
            id: contract && contract.id ? contract.id : null,
            additional_id: contract && contract.additional_id ? contract.additional_id : null,
            date_from: contract && contract.date_from ? new Date(contract.date_from) : '',
            date_to: contract && contract.date_to ? new Date(contract.date_to) : '',
            group_id: contract && contract.group_id ? contract.group_id : '',
            price: contract && contract.price ? contract.price : '',
            price_type: contract && contract.price_type ? contract.price_type : '',
            price_for: contract && contract.price_for ? contract.price_for : '',
            entrance_fee: contract && contract.entrance_fee ? contract.entrance_fee : '',
            entrance_fee_to: contract && contract.entrance_fee_to ? new Date(contract.entrance_fee_to) : '',
            sale_value: contract && contract.sale_value ? contract.sale_value : '',
            sale_type: contract && contract.sale_type ? contract.sale_type : '',
            status: contract && contract.status ? contract.status : '',
            end_date: contract && contract.end_date ? new Date(contract.end_date) : '',
            reason_template: contract && contract.reason_template ? contract.reason_template : '',
            visiting: contract && contract.visiting ? contract.visiting : '',
            type: locationParams.type,
            object_id: contract && contract.object_id ? contract.object_id : client.id,
            department_id: contract && contract.department_id ? contract.department_id : currentDepartment,
            editing: contract && contract.editing ? contract.editing : false
        }

        return data
    }

    const formik = useFormik({
            initialValues: {
                contracts: [initialContractData()],
                status: false
            },
            validate: (data) => {
                let errors = {}


                data.contracts.map((contract, contractIndex) => {
                    if (contract) {

                        if (!contract.date_from) {
                            errors['contracts.' + contractIndex + '.date_from'] = 'Обязательное поле!'
                        }
                        if (!contract.date_to) {
                            errors['contracts.' + contractIndex + '.date_to'] = 'Обязательное поле!'
                        }

                        if (['kindergarten', 'school', 'summer_camp'].includes(locationParams.type)) {
                            if (!contract.group_id) {
                                errors['contracts.' + contractIndex + '.group_id'] = 'Обязательное поле!'
                            }
                            if (!contract.visiting) {
                                errors['contracts.' + contractIndex + '.visiting'] = 'Обязательное поле!'
                            }
                        }
                        if (['additional_class', 'individual_lesson'].includes(locationParams.type)) {
                            if (!contract.additional_id) {
                                errors['contracts.' + contractIndex + '.additional_id'] = 'Обязательное поле!'
                            }
                        }
                        if (!contract.price) {
                            errors['contracts.' + contractIndex + '.price'] = 'Обязательное поле!'
                        }
                        if (['kindergarten', 'school'].includes(locationParams.type)) {
                            if (!contract.price_type) {
                                errors['contracts.' + contractIndex + '.price_type'] = 'Обязательное поле!'
                            }
                        } else {
                            if (!contract.price_for) {
                                errors['contracts.' + contractIndex + '.price_for'] = 'Обязательное поле!'
                            }
                        }


                        if (!contract.status) {
                            errors['contracts.' + contractIndex + '.status'] = 'Обязательное поле!'
                        }

                        if (contract.status && contract.status === 70) {
                            if (!contract.end_date) {
                                errors['contracts.' + contractIndex + '.end_date'] = 'Обязательное поле!'
                            }
                            if (!contract.reason_template) {
                                errors['contracts.' + contractIndex + '.reason_template'] = 'Обязательное поле!'
                            }
                        }


                    }

                })



                if(data.status === false){
                    errors.status = 'Укажите статус!';
                }

                // if(errors){
                //     toast.current.show({severity: 'error', summary: 'Заполните обязательные поля!'});
                // }

                console.log(errors)

                return errors


            },
            onSubmit: (data) => {

                setIsLoaded(false)
                ClientService.UpdateContracts(client.id, data, locationParams.type).then((r) => {
                    context.updateUser()
                    toast.current.show({severity: 'success', summary: 'Данные успешно сохранены!'});
                })
            }
        }
    )

    useEffect(() => {
        // console.log('sf')
        setIsLoaded(false)
        formik.setFieldValue('contracts', [], false)

        if (client) {
            const currentContracts = [];

            const statusObject = client.statuses.find((el) => {
                return el.type === locationParams.type
            })

            if (statusObject) {
                formik.setFieldValue('status', statusObject.status, true)
            } else {
                formik.setFieldValue('status', false, false)
            }

            client.contractsw.filter((el, k) => {
                return el.type === locationParams.type && el.department_id === currentDepartment
            }).map((contractItem, k) => {
                currentContracts.push(initialContractData(contractItem))
            })

            setTimeout(() => {
                formik.setFieldValue('contracts', currentContracts, false)
                setIsLoaded(true)
            }, 300)

            // }
            // console.log(formik.values)

        }
    }, [client, locationParams, currentDepartment])

    useEffect(() => {
        if (context) {
            console.log(context)
            setClient(context)
        }
    }, [context]);

    useEffect(() => {
        if (currentDepartment) {
            DepartmentService.getGroups({'filter': {'department_id': currentDepartment}}).then((response) => {
                setGroups(response.items)
            })
            DepartmentService.getAdditionals({'filter': {'department_id': currentDepartment}}).then((response) => {
                setAdditionals(response.items)
            })
        }
    }, [currentDepartment]);


    const handlerRemoveContract = (event, contactIndex) => {
        confirmPopup({
            target: event.currentTarget,
            message: 'Вы хотите удалить контракт?',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            accept: () => {
                let fv = formik.values
                delete fv.contracts[contactIndex]
                // console.log(fv)
                // formik.resetForm()
                formik.setValues(fv, false)
            },
            acceptLabel: 'Да',
            rejectLabel: 'Нет!'
        });

    }

    const isFormFieldInvalid = (name) => !!(formik.touched[name] && formik.errors[name]);

    const getFormErrorMessage = (name) => {
        return isFormFieldInvalid(name) ? <small className="p-error">{formik.errors[name]}</small> :
            <small className="p-error">&nbsp;</small>;
    };

    const getContractTitle = (contract) => {
        let title = ''

        if (contract && contract.group_id) {
            if (['kindergarten', 'school', 'summer_camp'].includes(contract.type)) {
                title += groups.find((el) => {
                    return el.id === contract.group_id
                }).name
            }
        }
        if (contract && contract.additional_id) {
            if (['additional_class', 'individual_lesson'].includes(contract.type)) {
                if (additionals && additionals.length > 0) {
                    title += additionals.find((el) => {
                        return el.id === contract.additional_id
                    }).name
                }
            }
        }

        // if (contract.date_from && contract.date_to) {
        //     title += ' (' + contract.date_from.toLocaleDateString() + ' – ' + contract.date_to.toLocaleDateString() + ')'
        // }
        // if (contract.price) {
        //     title += ', ' + contract.price + '₽'
        // }

        return <div className={'d-flex align-items-center'}>
            <strong>{title}</strong>

            <div className={'m-l-20'}>
                <i className={'pi pi-calendar m-r-5'}></i>
                {contract.date_from && contract.date_from.toLocaleDateString()} – {contract.date_to && contract.date_to.toLocaleDateString()}
            </div>
        </div>
    }

    const getContractStatusText = (contract) => {
        if (contract && contract.status && contractStatuses && contractStatuses.length) {
            return contractStatuses.find((el) => {
                return el.value === contract.status
            }).name
        }
    }


    return (
        <>
            <Toast ref={toast}></Toast>
            <div className="card">
                <div className="card-header b-b-light d-flex justify-content-between align-items-center">

                    <h3 className={''}> {contractTypes[locationParams.type]}</h3>

                    {client && client.statusList &&
                    <div className={'w-50'}>
                        <Dropdown options={Object.keys(client.statusList[locationParams.type || 'all'] || {}).map((key) => {

                            return {value: Number(key), label: client.statusList[locationParams.type || 'all'][key]}
                        })} optionLabel={'label'} value={formik.values.status} onChange={(e) => formik.setFieldValue('status', e.target.value)} placeholder={'Выберите статус'}
                              className={classNames({'p-invalid': formik.errors['status']})}
                        />
                        {getFormErrorMessage('status')}
                    </div>
                    }
                </div>
                <div className="card-body">


                    <h3 className={'f-w-400 m-b-30'}>Контракты</h3>
                    <form onSubmit={formik.handleSubmit}>
                        {isLoaded && groups ?
                            formik.values.contracts.map((contractModel, k) => {
                                if (contractModel) {
                                    if (contractModel.editing) {
                                        return (
                                            <div className={'contract card  card-absolute'}>
                                                {/*<div className={'card-header bg-default'}>ID{contractModel.id}</div>*/}
                                                <div className="card-header card-header_r bg-default">
                                                    <Button type={'button'} onClick={(e) => handlerRemoveContract(e, k)}
                                                            icon={'pi pi-times'}
                                                            className={'p-button-text p-button-rounded p-button-danger'} text={true}/>
                                                </div>
                                                <div className="card-body">

                                                    <div className="row">
                                                        <div className="col-auto">
                                                            <FormGroup label={'Срок контракта, от'}
                                                                       error={formik.errors['contracts.' + k + '.date_from']}>
                                                                <Calendar maxDate={contractModel.date_to}
                                                                          value={contractModel.date_from}
                                                                          className={classNames({'p-invalid': formik.errors['contracts.' + k + '.date_from']})}
                                                                          onChange={(e) => formik.setFieldValue('contracts.' + k + '.date_from', e.target.value)}/>
                                                            </FormGroup>
                                                        </div>
                                                        <div className="col-auto">
                                                            <FormGroup label={'Срок контракта, до'}
                                                                       error={formik.errors['contracts.' + k + '.date_to']}>
                                                                <Calendar minDate={contractModel.date_from}
                                                                          value={contractModel.date_to}
                                                                          className={classNames({'p-invalid': formik.errors['contracts.' + k + '.date_to']})}
                                                                          onChange={(e) => formik.setFieldValue('contracts.' + k + '.date_to', e.target.value)}/>
                                                            </FormGroup>
                                                        </div>
                                                        <div className="col-md-6">
                                                            {locationParams.type === 'additional_class' || locationParams.type === 'individual_lesson' ?

                                                                <FormGroup label={'Услуга'}
                                                                           error={formik.errors['contracts.' + k + '.additional_id']}>
                                                                    <Dropdown
                                                                        onChange={(e) => formik.setFieldValue('contracts.' + k + '.additional_id', e.target.value)}
                                                                        filter value={contractModel.additional_id}
                                                                        className={classNames({'p-invalid': formik.errors['contracts.' + k + '.additional_id']})}
                                                                        options={(additionals && additionals.filter((option) => {
                                                                            return option.type === (locationParams.type === 'additional_class' ? 'additional' : 'individual')
                                                                        }).map((option) => {
                                                                            return {
                                                                                label: option.name,
                                                                                value: option.id
                                                                            }
                                                                        }))}/>
                                                                </FormGroup>
                                                                : ''}
                                                        </div>
                                                    </div>


                                                    {['kindergarten', 'school', 'summer_camp'].includes(locationParams.type) &&
                                                        <ScrollPanel style={{width: '100%'}}>
                                                            <FormGroup label={'Группа / Класс'}
                                                                       error={formik.errors['contracts.' + k + '.group_id']}>
                                                                <SelectButton
                                                                    className={classNames({'p-invalid': formik.errors['contracts.' + k + '.group_id']})}
                                                                    options={groups.map((group) => {
                                                                        return {label: group.name, value: group.id}
                                                                    })} optionLabel={'label'}
                                                                    value={contractModel.group_id}
                                                                    onChange={(e) => formik.setFieldValue('contracts.' + k + '.group_id', e.target.value)}/>
                                                            </FormGroup>
                                                        </ScrollPanel>
                                                    }


                                                    {['kindergarten', 'school', 'summer_camp'].includes(locationParams.type) &&
                                                        <FormGroup label={'Режим посещения'}
                                                                   error={formik.errors['contracts.' + k + '.visiting']}
                                                                   labelOptions={{className: 'p-float-label'}}
                                                                   horizontal>
                                                            <SelectButton options={[
                                                                'полный день',
                                                                'полдня'
                                                            ]} value={contractModel.visiting}
                                                                          className={classNames({'p-invalid': formik.errors['contracts.' + k + '.visiting']})}
                                                                          onChange={(e) => formik.setFieldValue('contracts.' + k + '.visiting', e.target.value)}/>
                                                        </FormGroup>
                                                    }

                                                    <div className="row">
                                                        <div className="col-auto">
                                                            <FormGroup label={'Цена'} horizontal
                                                                       error={formik.errors['contracts.' + k + '.price']}>
                                                                <InputNumber value={contractModel.price}
                                                                             maxFractionDigits={0}
                                                                             mode={'currency'} currency={'RUB'}
                                                                             className={classNames({'p-invalid': formik.errors['contracts.' + k + '.price']})}
                                                                             onChange={(e) => formik.setFieldValue('contracts.' + k + '.price', e.value)}/>
                                                            </FormGroup>
                                                        </div>
                                                        {['kindergarten', 'school'].includes(locationParams.type) &&
                                                            <div className="col">
                                                                <FormGroup label={'Периодичность оплаты'}
                                                                           labelOptions={{className: 'p-float-label'}}
                                                                           error={formik.errors['contracts.' + k + '.price_type']}
                                                                           horizontal>
                                                                    <SelectButton options={[
                                                                        {name: 'месяц', value: '1'},
                                                                        {name: 'квартал', value: '5'},
                                                                        {name: 'год', value: '10'},
                                                                    ]} optionLabel={'name'}
                                                                                  value={contractModel.price_type}
                                                                                  className={classNames({'p-invalid': formik.errors['contracts.' + k + '.price_type']})}
                                                                                  onChange={(e) => formik.setFieldValue('contracts.' + k + '.price_type', e.target.value)}/>
                                                                </FormGroup>
                                                            </div>
                                                        }
                                                        {['additional_class', 'individual_lesson', 'summer_camp'].includes(locationParams.type) &&
                                                            <div className="col">
                                                                <FormGroup label={'Периодичность оплаты'}
                                                                           labelOptions={{className: 'p-float-label'}}
                                                                           error={formik.errors['contracts.' + k + '.price_for']}
                                                                           horizontal>
                                                                    <SelectButton options={[
                                                                        {name: 'разовое', value: 'разовое'},
                                                                        {name: 'абонемент', value: 'абонемент'},
                                                                    ]} optionLabel={'name'}
                                                                                  value={contractModel.price_for}
                                                                                  className={classNames({'p-invalid': formik.errors['contracts.' + k + '.price_for']})}
                                                                                  onChange={(e) => formik.setFieldValue('contracts.' + k + '.price_for', e.target.value)}/>
                                                                </FormGroup>
                                                            </div>
                                                        }
                                                    </div>


                                                    {['kindergarten', 'school', 'summer_camp'].includes(locationParams.type) &&
                                                        <div className="row">
                                                            <div className="col-auto">
                                                                <FormGroup label={'Скидка'} horizontal
                                                                           error={getFormErrorMessage('sale_value')}>
                                                                    {contractModel.sale_type !== 1 &&
                                                                        <InputNumber mode={'currency'} currency={'RUB'}
                                                                                     value={contractModel.sale_value}
                                                                                     className=""
                                                                                     onChange={(e) => formik.setFieldValue('contracts.' + k + '.sale_value', e.value)}/>
                                                                    }
                                                                    {contractModel.sale_type === 1 &&
                                                                        <InputNumber
                                                                            value={contractModel.sale_value}
                                                                            className=""
                                                                            onChange={(e) => formik.setFieldValue('contracts.' + k + '.sale_value', e.value)}/>

                                                                    }
                                                                </FormGroup>
                                                            </div>
                                                            <div className="col">
                                                                <FormGroup label={'Тип скидки'}
                                                                           labelOptions={{className: 'p-float-label'}}
                                                                           horizontal>
                                                                    <SelectButton options={[
                                                                        {name: '%', value: 1},
                                                                        {name: 'сумма', value: 5},
                                                                    ]} optionLabel={'name'}
                                                                                  value={contractModel.sale_type}
                                                                                  onChange={(e) => formik.setFieldValue('contracts.' + k + '.sale_type', e.target.value)}/>
                                                                </FormGroup>
                                                            </div>
                                                        </div>
                                                    }

                                                    {['kindergarten', 'school', 'summer_camp'].includes(locationParams.type) &&
                                                        <div className="row">
                                                            <div className="col-auto">
                                                                <FormGroup label={'Вступительный взнос'} horizontal>
                                                                    <InputNumber value={contractModel.entrance_fee}
                                                                                 maxFractionDigits={0}
                                                                                 mode={'currency'} currency={'RUB'}
                                                                                 onChange={(e) => formik.setFieldValue('contracts.' + k + '.entrance_fee', e.value)}/>
                                                                </FormGroup>
                                                            </div>
                                                            <div className="col">
                                                                <FormGroup label={'Крайний срок'} horizontal>
                                                                    <Calendar value={contractModel.entrance_fee_to}
                                                                              onChange={(e) => formik.setFieldValue('contracts.' + k + '.entrance_fee_to', e.target.value)}/>
                                                                </FormGroup>
                                                            </div>
                                                        </div>
                                                    }
                                                    <FormGroup label={'Статус'}
                                                               error={formik.errors['contracts.' + k + '.status']}>
                                                        <SelectButton options={contractStatuses} optionLabel={'name'}
                                                                      value={contractModel.status}
                                                                      className={classNames({'p-invalid': formik.errors['contracts.' + k + '.status']})}
                                                                      onChange={(e) => formik.setFieldValue('contracts.' + k + '.status', e.target.value)}/>
                                                    </FormGroup>

                                                    {contractModel.status === 70 &&
                                                        <div className="row">
                                                            <div className="col-auto">
                                                                <FormGroup label={'Дата прекращения'}
                                                                           error={formik.errors['contracts.' + k + '.end_date']}>
                                                                    <Calendar minDate={contractModel.date_from}
                                                                              maxDate={contractModel.date_to}
                                                                              value={contractModel.end_date}
                                                                              className={classNames({'p-invalid': formik.errors['contracts.' + k + '.end_date']})}
                                                                              onChange={(e) => formik.setFieldValue('contracts.' + k + '.end_date', e.target.value)}/>
                                                                </FormGroup>
                                                            </div>
                                                            <div className="col-auto">
                                                                <FormGroup label={'Причина прекращения'}
                                                                           error={formik.errors['contracts.' + k + '.reason_template']}>
                                                                    <Dropdown options={[
                                                                        {value: '100', label: 'выпуск в школу'},
                                                                        {value: '95', label: 'тяжелая адаптация'},
                                                                        {
                                                                            value: '80',
                                                                            label: 'уход в другой частный сад'
                                                                        },
                                                                        {value: '90', label: 'уход в гос сад'},
                                                                        {value: '70', label: 'психические отклонения'},
                                                                        {value: '60', label: 'переезд'},
                                                                        {value: '50', label: 'часто болеет'},
                                                                        {value: '40', label: 'конфликт с персоналом'},
                                                                        {value: '30', label: 'другое'}
                                                                    ]} value={contractModel.reason_template}
                                                                              className={classNames({'p-invalid': formik.errors['contracts.' + k + '.reason_template']})}
                                                                              onChange={(e) => formik.setFieldValue('contracts.' + k + '.reason_template', e.target.value)}/>
                                                                </FormGroup>


                                                            </div>
                                                        </div>
                                                    }


                                                    {contractModel.id &&
                                                        <button type={'button'} className={'btn btn-default btn-xs'}
                                                                onClick={(e) => formik.setFieldValue('contracts.' + k + '.editing', false)}>Свернуть
                                                        </button>
                                                    }

                                                </div>


                                            </div>
                                        )
                                    } else {
                                        return (
                                            <div className={'card m-b-0'}>
                                                <div className="card-header">
                                                    <div className={'d-flex justify-content-between'}>

                                                        <div>{getContractTitle(contractModel)}</div>

                                                        <div className={'ml-auto d-flex align-items-center'}>
                                                            <div
                                                                className={'m-r-10 badge badge-primary'}>{getContractStatusText(contractModel)}</div>
                                                            <button type={'button'}
                                                                    onClick={(e) => formik.setFieldValue('contracts.' + k + '.editing', true)}
                                                                    className={'btn btn-xs'}>
                                                                <i className={'pi pi-pencil'}></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        )
                                    }
                                }
                            })
                            : <Loader/>}
                        <div className={'m-t-30'}>
                            <Button className={'p-button-outlined'} icon={'pi pi-plus'} type={'button'}
                                    label={'Добавить контракт'} onClick={() => addContract()}/>
                        </div>

                    </form>
                </div>
                <div className="card-footer">
                    <Button type={'submit'} onClick={formik.handleSubmit} label={'Сохранить'}/>
                </div>
            </div>

        </>
    )
}